import {makeItemsListUrl} from '@frontend/helpers'
import type {AdCategory} from '@frontend/modules/public/ads/AdsModuleTypes'
import {mdiChevronDown} from '@mdi/js'
import {DropdownItem} from 'swayok-react-mdb-ui-kit/components/Dropdown/DropdownItem'
import {IconButton} from 'swayok-react-mdb-ui-kit/components/Icon/IconButton'

interface CategorySelectorDropdownMenuItemProps {
    category: AdCategory
    onCategoryChange: (newCategory: AdCategory | null) => void
    onCategoryToggle?: (category: AdCategory) => void
    className?: string
}

// Категория и ее подкатегории для выпадающего меню выбора категории для фильтрации.
export function CategorySelectorDropdownMenuItem(props: CategorySelectorDropdownMenuItemProps) {

    const {
        category,
        className,
        onCategoryChange,
        onCategoryToggle,
    } = props

    return (
        <div className="flex-row-center-vertical">
            <DropdownItem
                key={'category-' + String(category.id)}
                className={className}
                href={makeItemsListUrl(category)}
                onClick={e => {
                    e.preventDefault()
                    onCategoryChange(category)
                }}
            >
                {category.name}
            </DropdownItem>
            {category.children?.length > 0 && onCategoryToggle && (
                <IconButton
                    path={mdiChevronDown}
                    className="px-2"
                    onClick={e => {
                        e.preventDefault()
                        e.stopPropagation()
                        onCategoryToggle(category)
                    }}
                />
            )}
        </div>
    )
}
